import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/dearest/coaches/page";

export const Route = createFileRoute(
  "/clients/$clientId/dashboard/dearest/coaches",
)({
  component: Page,
});
